// This file is used for maintain and manage API services.
(function() {
  'use strict';
  angular.module('obex').
  factory('travelerTrack', ['$http', 'obexConstant', 'authService',
    ($http, obexConstant, authService) => {
      return {
        getAlerts() {
          const url = `${obexConstant.urlTravelerTrack}/Alerts/15`;
          return authService.getAuthorizationHeader().then(authHeader =>
            $http.get(url, {
              headers: authHeader,
            }));
        },
        getTravelers(startDate, endDate, travelersNearAlert, organizationId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url =
              `${obexConstant.urlTravelerTrack}/Travelers/${startDate}/${endDate}/${travelersNearAlert}/${organizationId}`;             
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        getDepartureCities(clientId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url =
              `${obexConstant.urlTravelerCities}/departurecities/${clientId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        getArrivalCities(clientId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url =
              `${obexConstant.urlTravelerCities}/arrivalcities/${clientId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        adminTripById(tripId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlTrips}/admin/${tripId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        adminFlightById(flightId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlFlights}/admin/${flightId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        adminHotelById(hotelId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlHotels}/admin/${hotelId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        adminCarById(carId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlCars}/admin/${carId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        getTravelerExportList(startDate, endDate, travelersNearAlert, organizationId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url =
              `${obexConstant.urlTravelerTrack}/ExportTravelers/${startDate}/${endDate}/${travelersNearAlert}/${organizationId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
      };
    },
  ]);
})();


// WEBPACK FOOTER //
// ./client/js/services/travelerTrack.service.js